import React from 'react';

import { AttentionMessage } from '@eika/attention-message';
import { IconTypes } from '@eika/icon';
import { Link } from '@eika/link';
import { Modal } from '@eika/modal';

import { useConfigLink } from '@domain/app';
import useText from '@hooks/use-text';

export const DigitalCardLowAssuranceWarning = ({ onClose }: { onClose(): void }) => {
    const { digitalCardLowAssuranceText, googleWalletStepUpProceed, digitalCardTitle } = useText();

    const link = useConfigLink('stepUpAuthLink', { url: '/' });

    return (
        <Modal title={digitalCardTitle} open setOpen={onClose}>
            <AttentionMessage
                type="warning"
                id="google-pay-low-assurance"
                text={digitalCardLowAssuranceText}
                icon={IconTypes.INFO_24}
                clickableItem={<Link href={link.url}>{googleWalletStepUpProceed}</Link>}
            />
        </Modal>
    );
};
